import script from "./sw-item-parts-fullname.vue?vue&type=script&setup=true&lang=js"
export * from "./sw-item-parts-fullname.vue?vue&type=script&setup=true&lang=js"

import "./sw-item-parts-fullname.vue?vue&type=style&index=0&id=33caddbd&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-33caddbd"]])

export default __exports__